import cookie from "react-cookies";

const LOGIN_COOKIE = 'isLogin'

export function isAuthenticated () {
  return _getCookie(LOGIN_COOKIE)
}

export function authenticateSuccess (isLogin) {
  _setCookie(LOGIN_COOKIE, isLogin, 7)
}

export function set_bcz_internal_token(token) {
  let expireDate = new Date(new Date().getTime() + 24 * 3600 * 1000 * 30);
  cookie.save("bcz_internal_token", token, {domain:".baicizhan.com", maxAge:expireDate, path: "/"});
  cookie.save("bcz_internal_token", token, {maxAge:expireDate, path: "/home"});
}

export function get_bcz_internal_token() {
  return cookie.load('bcz_internal_token');
}

export function logout () {
  _setCookie(LOGIN_COOKIE, false, 0)
  cookie.remove("bcz_internal_token", {path:"/"});
  cookie.remove("bcz_internal_token", {domain:".baicizhan.com",path:"/"})
}

function _getCookie (name) {
  let start, end
  if (document.cookie.length > 0) {
    start = document.cookie.indexOf(name + '=')
    if (start !== -1) {
      start = start + name.length + 1
      end = document.cookie.indexOf(';', start)
      if (end === -1) {
        end = document.cookie.length
      }
      return unescape(document.cookie.substring(start, end))
    }
  }
  return ''
}

function _setCookie (name, value, expire) {
  let date = new Date()
  date.setDate(date.getDate() + expire)
  document.cookie = name + '=' + escape(value) + '; path=/' +
    (expire ? ';expires=' + date.toGMTString() : '')
}

function _set_bcz_internal_token_Cookie(name, value, expire) {
  let date = new Date()
  date.setDate(date.getDate() + expire)
  document.cookie = name + '=' + escape(value) + '; path=/' + ';domain=.baicizhan.com' +
      (expire ? ';expires=' + date.toGMTString() : '')
}


// WEBPACK FOOTER //
// ./src/utils/Session.js